import React, { useEffect, useState } from 'react'
import {
  LoadingContainer,
  LoadingTextAnimation,
  pulseAnimation,
  shimmerAnimation,
} from './styles/LoadingText.styles'

interface LoadingTextProps {
  children?: React.ReactNode
  isLoading?: boolean
  css?: any // Emotion CSS prop
  [key: string]: any // Additional props
}

const LoadingText: React.FC<LoadingTextProps> = ({
  children,
  isLoading = false,
  css,
  ...props
}) => {
  const [isEmpty, setIsEmpty] = useState<boolean>(false)

  useEffect(() => {
    // Check if children is empty, handling both string and React elements
    setIsEmpty(
      children === null ||
        children === undefined ||
        (typeof children === 'string' && children.trim() === '') ||
        (Array.isArray(children) && children.length === 0),
    )
  }, [children])

  if (isLoading || isEmpty) {
    return (
      <span css={css} {...props}>
        <LoadingContainer>
          <LoadingTextAnimation>
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </LoadingTextAnimation>
        </LoadingContainer>
      </span>
    )
  }

  return (
    <span css={css} {...props}>
      {children}
    </span>
  )
}

export default LoadingText

export { pulseAnimation, shimmerAnimation }
